import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=57228e2a&scoped=true&"
import script from "./addOrEdit.vue?vue&type=script&lang=js&"
export * from "./addOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=57228e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57228e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57228e2a')) {
      api.createRecord('57228e2a', component.options)
    } else {
      api.reload('57228e2a', component.options)
    }
    module.hot.accept("./addOrEdit.vue?vue&type=template&id=57228e2a&scoped=true&", function () {
      api.rerender('57228e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customsCodeManage/components/addOrEdit.vue"
export default component.exports